<template>
    <div class="container max-w-3xl mx-auto -mb-5">
        <h1 class="page-title">Book your appointment</h1>

        <div class="tabs">
            <ul>
                <li tabindex="0" :class="tabClasses('details')" @click.prevent="selectTab('details')">
                    Your details
                </li>
                <li tabindex="0" :class="tabClasses('injury')" @click.prevent="selectTab('injury')">
                    Your injury
                </li>
                <li tabindex="0" :class="tabClasses('payment')" @click.prevent="selectTab('payment')">
                    Payment
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'tabs',

        props: {
            active: {
                type: String,
                required: true,
            },
        },

        computed: mapState('checkout', [
            'patientDetailsValid',
            'injuryDetailsValid',
            'paymentDetailsValid',
        ]),

        data() {
            return {
                activeTab: null,
                tabStoreMap: {
                    details: 'patientDetailsValid',
                    injury: 'injuryDetailsValid',
                    payment: 'paymentDetailsValid',
                }
            };
        },

        mounted() {
            this.activeTab = this.active;

            this.listen('checkout.tab', this.setTab)
        },

        destroyed() {
            this.silence('checkout.tab', this.setTab)
        },

        methods: {
            setTab(tab) {
                this.activeTab = tab;
            },

            selectTab(tab) {
                if (tab !== 'details') {
                    if (this.previousFormIsValid(tab) === false) {
                        return false;
                    }
                }

                this.dispatch('checkout.tab', tab);
            },

            tabClasses(tab) {
                let classes = [];

                if (this.activeTab === tab) {
                    classes.push('active');
                } else if (!this.previousFormIsValid(tab)) {
                    classes.push('disabled');
                }

                return classes;
            },

            previousFormIsValid(tab) {
                switch (tab) {
                    case 'details':
                        return true;

                    case 'injury':
                        return this.patientDetailsValid;

                    case 'payment':
                        return this.injuryDetailsValid;
                }
            },
        },
    }
</script>
